import { RegisterTicketForm } from "@/features/user/forms/register-ticket-form";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";
import { useLng } from "@/hooks/use-lng";

export const Route = createFileRoute("/_app/account/_auth/activateticket")({
  head: () => appTitleHead("account-activate-ticket-title"),
  component: ActivateTicketPage
});

function ActivateTicketPage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");

  return (
    <div className="flex h-full flex-col justify-between">
      <div>
        <h1 className="hidden text-left md:block">{t("activate-ticket")}</h1>
        <p>{t("activate-ticket-description")}</p>
        <RegisterTicketForm />
      </div>
    </div>
  );
}
